module.exports = __webpack_public_path__ + "media/images/service/c_4-abae562019b3411c8959b7d69e94b8fd.png";